import { DetectSiteDomain } from '@utils/detect-site-domain'
import { CheckoutEventDTO } from '../../../../types/analytics/analytics-data'
import { CheckoutState } from '@hooks/use-checkout'
import { checkoutStateSynsisalToDTO, checkoutStateToDTO } from '@utils/analytics/transformations/checkout'

export const createPurchaseDTO = (
  data: CheckoutState,
  siteDomainInfo: DetectSiteDomain,
  promoCode?: string,
  transactionId?: string,
  previousRoute?: string,
): CheckoutEventDTO | undefined => {
  const { synsisalSite } = siteDomainInfo
  if (!data) {
    return
  }
  // Synsisal Site
  if (synsisalSite) {
    return checkoutStateSynsisalToDTO(data, transactionId, previousRoute)
  }
  // Furniture and Flooring
  return checkoutStateToDTO(data, siteDomainInfo, promoCode, transactionId)
}
